import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { observer } from 'mobx-react-lite';
import HomeIcon from '@mui/icons-material/Home';
import { IconButton, Typography } from '@mui/material';

import { URLService } from '@/dmdrive/core/service/URLService';

import { HeaderLeftBlock, HeaderRoot, HomeLink } from './Header.styles';

import UserMenu from './UserMenu/UserMenu';

function Header() {
  const navigate = useNavigate();

  const onNavigateHome = useCallback(() => navigate(URLService.main()), []);

  return (
    <HeaderRoot>
      <HeaderLeftBlock>
        <IconButton onClick={onNavigateHome}>
          <HomeIcon fontSize="small" />
        </IconButton>

        <HomeLink to={URLService.main()}>
          <Typography variant="body2" component="span">
            DMDrive
          </Typography>
        </HomeLink>
      </HeaderLeftBlock>

      <UserMenu />
    </HeaderRoot>
  );
}

export default observer(Header);
